import { render, staticRenderFns } from "./costSummary.vue?vue&type=template&id=00c8a6e1&scoped=true&"
import script from "./costSummary.vue?vue&type=script&lang=js&"
export * from "./costSummary.vue?vue&type=script&lang=js&"
import style0 from "./costSummary.vue?vue&type=style&index=0&id=00c8a6e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8a6e1",
  null
  
)

export default component.exports